module.exports = __webpack_public_path__ + "img/fashion_18.03c52025.jpg";